export enum NotificationTemplateType {
  ProjectRelianceStatusUpdateWithStateAndReason = "PROJECT_RELIANCE_STATUS_UPDATE_WITH_STATE_AND_REASON",
  ProjectRelianceStatusUpdateWithStateAndReasonRevert = "PROJECT_RELIANCE_STATUS_UPDATE_WITH_STATE_AND_REASON_REVERT",
  AssetHAQImportParsingFail = "ASSET_HAQ_IMPORT_PARSING_FAIL",
  AssetHAQImportParsingComplete = "ASSET_HAQ_IMPORT_PARSING_COMPLETE",
  DocumentCopy = "DOCUMENT_COPY",
}
